import { map } from 'lodash/fp';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ContentCard, DefaultErrorBoundary } from '@mews-commander/ui';
import { TableWrapperElement } from '@mews-commander/ui/legacy';
import { ApplicationState, Product } from '@mews-commander/types';
import { isCurrentEnterpriseInMultiTaxEnvironment } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { getServiceTimeUnitPluralKey } from '@mews-commander/legacy-entities/src/utils/serviceTimeUnitLocalization';
import { ProductOrderGroup } from '../../transformProductOrders/types';
import { getSortedProductOrderGroups } from '../../transformProductOrders/groupProductOrders';
import { ItemsTableElement, ItemsTableRowElement, ItemsTableHeaderCellElement } from './styles';
import { ProductOrderGroupRow } from './ProductOrderGroupRow';

const ProductOrders = ({
    isMultiTaxEnvironment,
    productOrderGroups,
    refetchGroup,
    groupId,
    accountId,
    timeUnitKey,
}: ProductOrdersProps) => {
    const renderProductOrderGroupRow = (group: ProductOrderGroup) => (
        <ProductOrderGroupRow
            refetchGroup={refetchGroup}
            timeUnitKey={timeUnitKey}
            group={group}
            groupId={groupId}
            accountId={accountId}
            key={group.id}
            isMultiTaxEnvironment={isMultiTaxEnvironment}
        />
    );
    return (
        <DefaultErrorBoundary>
            <ContentCard title={<LocalizedText textKey={TextKey.ProductOrders} />} data-test-product-orders-table>
                <TableWrapperElement>
                    <ItemsTableElement>
                        <ItemsTableRowElement>
                            <ItemsTableHeaderCellElement>
                                <LocalizedText textKey={TextKey.Product} />
                            </ItemsTableHeaderCellElement>
                            <ItemsTableHeaderCellElement>
                                <LocalizedText textKey={TextKey.Cost} />
                            </ItemsTableHeaderCellElement>
                            <ItemsTableHeaderCellElement>
                                <LocalizedText textKey={TextKey.Consumed} />
                            </ItemsTableHeaderCellElement>
                            <ItemsTableHeaderCellElement>
                                <LocalizedText textKey={TextKey.Bill} />
                            </ItemsTableHeaderCellElement>
                            <ItemsTableHeaderCellElement />
                        </ItemsTableRowElement>
                        {map(renderProductOrderGroupRow, productOrderGroups)}
                    </ItemsTableElement>
                </TableWrapperElement>
            </ContentCard>
        </DefaultErrorBoundary>
    );
};

interface ProductOrdersProps {
    isMultiTaxEnvironment: boolean;
    productOrderGroups: ProductOrderGroup[];
    refetchGroup: () => void;
    groupId: string;
    accountId: string;
    timeUnitKey: Mews.TextKey;
    products: Product[];
}

interface OwnProps {
    reservationId: string;
    serviceId: string;
}

const connectProductOrders = connect(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        isMultiTaxEnvironment: isCurrentEnterpriseInMultiTaxEnvironment,
        timeUnitKey: (state: ApplicationState, { serviceId }: OwnProps) =>
            getServiceTimeUnitPluralKey(state, { id: serviceId }),
        productOrderGroups: (state: ApplicationState, { reservationId, serviceId }: OwnProps) =>
            getSortedProductOrderGroups(state, { serviceOrderIds: [reservationId], serviceId }),
    })
);

// @ts-expect-error $TSFixMeError: Argument of type '({ isMultiTaxEnvironment, productOrderGroups, refetchGroup, groupId, accountId, timeUnitKey, }: Produc...
export default connectProductOrders(ProductOrders);
